import { useContext } from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import LocaleContext from '../contexts/locale';

const all = [];
const map = {};

const useBlockAnnouncement = () => {
	const {
		allMarkdownRemark: {
			edges: blocks
		}
	} = useStaticQuery(query);

	const {
		currentLocale
	} = useContext(LocaleContext);

	const mapItem = ({
		node: {
			id,
			html,
			fields,
			frontmatter: data
		}
	}) => ({
		...data,
		...fields,
		...{
			id,
			html
		}
	});

	if (all.length === 0) {
		for (let block of blocks) {
			const item = mapItem(block);
			const { locale } = item;

			map[locale] = item;
			all.push(item);
		}
	}

	return map[currentLocale];
}

export default useBlockAnnouncement;

const query = graphql`
	query useBlockAnnouncementQuery {
		allMarkdownRemark(
	    	filter: {
		        frontmatter: {
		          type: {
		            eq: "block"
		          }
		          name: {
		          	eq: "announcement"
		          }
		        }
		  	}
	  	)
	  	{
			edges {
				node {
					id
					html
					frontmatter {
						title
						intro
						image {
							publicURL
						}
						button_text
						button_link
					}
					fields {
						locale
					}
				}
			}
		}
	}
`;
